import { Observable, rx } from '@shared/rx';
import {
  makeOnControlChangedOperator,
  IOnControlChangedOperator,
  IValueMakers,
} from './on-control-changed-base';

const valueMakers: IValueMakers<any> = {
  withDefaultValue: (control): Observable<any> =>
    control.valueChanges.pipe(rx.startWith(control.value)),
  noDefaultValue: (control): Observable<any> => control.valueChanges,
};

export const onControlValueChanged: IOnControlChangedOperator<any> =
  makeOnControlChangedOperator(valueMakers);
